// api
import ModelService from '@/services/model.service'
import { mapState } from 'vuex'

export default {
  name: 'Founders',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdListPc: [34, 30, 54, 72, 89],
      adIdListMb: [39, 40, 57, 74, 91],
      // data
      isShow: false,
      swiperSlides: '',
      leaderList: [],
      curleaderData: '',
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 'auto',
        freeMode: true,
        scrollbar: {
          el: '.swiper-scrollbar'
        },
        mousewheel: true
      }
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.init();
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getContentList();
      this.getBackground();
    },
    getBackground() {
      if (this.isPC) {
        this.getPcPicture();
      } else {
        this.getMobilePic();
      }
    },
    // 根据id获取广告图片
    getPcPicture() {
      const param = {
        lang: this.language,
        adId: this.adIdListPc[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.swiperSlides = res.data[0];
        }
      });
    },
    // 根据id获取广告图片
    getMobilePic() {
      const param = {
        lang: this.language,
        adId: this.adIdListMb[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.swiperSlides = res.data[0];
        }
      });
    },
    // 获取领导人列表
    // http://www.epfootwear.com:8080/api/content/list?lang=EN&module=leader&type=2
    getContentList() {
      const param = {
        lang: this.language,
        module: 'leader',
        type: 2,
      };
      ModelService.getContentList(param).then((res) => {
        if (res.code === 0) {
          this.leaderList = res.data;
        }
      });     
    },
    closePopup() {
      this.isShow = false;
    },
    openPopup(index) {
      this.isShow = true;
      this.curleaderData = this.leaderList[index];
    },
  },
};
